<template>
  <!--普通应用行业-->
  <div class="contents-goods-box" id="industry">
    <div class="contents">
      <div class="contents about-contents-img">
        <img :width="titleWidth" :src="industryTitleImg" />
      </div>
      <div class="p-industry-list">
        <!-- 335 200  -->
        <div
          class="p-industry-list-item"
          :class="{
            'p-industry-list-item-f': pindustry.length == 10,
            'p-industry-list-item-ff': pindustry.length == 8
          }"
          v-for="(item, index) in pindustry"
          :style="{
            background: 'url(' + item.bjimg + ') no-repeat center/100% 100%'
          }"
        >
          <div class="p-industry-list-item-contents-box">
            <div class="p-industry-list-item-contents">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    industryTitleImg: {
      type: String,
      required: true,
      default: ""
    },
    titleWidth: {
      type: String,
      default: "740px"
    },
    pindustry: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style scoped>
.contents-goods-box {
  background-color: #fff;
  overflow: hidden;
  background: url(/static/brand/aboutusbj.png) no-repeat center top;
}
.about-contents-img {
  margin-top: 45px;
  margin-bottom: 60px;
  text-align: center;
}
.p-industry-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.p-industry-list-item {
  position: relative;
  width: 335px;
  height: 335px;
  background-color: red;
  margin-bottom: 97px;
  border-radius: 12px;
}
.p-industry-list-item.p-industry-list-item-f {
  width: 202px;
  height: 202px;
  margin-bottom: 55px;
  border-radius: 10px;
  background-size: 100% 100% !important;
}

.p-industry-list-item.p-industry-list-item-ff {
  width: 255px;
  height: 255px;
  margin-bottom: 55px;
  border-radius: 10px;
  background-size: 100% 100% !important;
}

.p-industry-list-item .p-industry-list-item-contents-box {
  display: none;
  width: 335px;
  height: 335px;
  overflow: hidden;
  border-radius: 20px;
}
.p-industry-list-item.p-industry-list-item-f
  .p-industry-list-item-contents-box {
  display: none;
  width: 202px;
  height: 202px;
  overflow: hidden;
}
.p-industry-list-item.p-industry-list-item-ff
  .p-industry-list-item-contents-box {
  display: none;
  width: 255px;
  height: 255px;
  overflow: hidden;
}
.p-industry-list-item:hover .p-industry-list-item-contents-box {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 25px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.p-industry-list-item .p-industry-list-item-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 300px;
  height: 300px;
  border: 2px solid rgb(255, 255, 255, 0.5);
}
.p-industry-list-item.p-industry-list-item-f .p-industry-list-item-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 178px;
  height: 178px;
  border: 2px solid rgb(255, 255, 255, 0.5);
}
.p-industry-list-item.p-industry-list-item-ff .p-industry-list-item-contents {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: 220px;
  height: 220px;
  border: 2px solid rgb(255, 255, 255, 0.5);
}
.p-industry-list-item.p-industry-list-item-f
  .p-industry-list-item-contents
  span {
  opacity: 1;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/OtherIndustryList.vue